import script from "./ElementDataSourceIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementDataSourceIcon.vue?vue&type=script&setup=true&lang=js"

import "./ElementDataSourceIcon.vue?vue&type=style&index=0&id=1c1a1c32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c1a1c32"]])

export default __exports__